<template>
  <div class="personal-profile">
    <el-form :model="applyForm" ref="applyForm" label-width="86px" class="apply-form" :rules="applyFormRules">
      <el-form-item label="用户名">
        <span>{{ applyForm.account }}</span>
      </el-form-item>
      <el-form-item label="邮箱" prop="email" inline-message>
        <el-input v-model="applyForm.email" maxlength="80"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name" maxlength="80">
        <el-input v-model="applyForm.name"></el-input>
      </el-form-item>
      <el-form-item label="部门" prop="department" maxlength="80">
        <el-input v-model="applyForm.department"></el-input>
      </el-form-item>
      <el-form-item label="职位" prop="position" maxlength="80">
        <el-input v-model="applyForm.position"></el-input>
      </el-form-item>
      <el-form-item label="办公电话" prop="tel" maxlength="14">
        <el-input v-model="applyForm.tel"></el-input>
      </el-form-item>
      <el-form-item v-if="applyForm.mobile" label="手机号码">
        <span>{{ applyForm.mobile }}</span>
        <a href="javascript:void(0)" @click="bindPhone('update', 'getCodeTimer')">更换号码</a>
        <a href="javascript:void(0)" @click="unbindPhone">解绑号码</a>
      </el-form-item>
      <el-form-item v-else label="手机号码">
        <span>未绑定手机号码，<a href="javascript:void(0)" style="margin:0" @click="bindPhone('bind', 'getCodeTimer')">去绑定</a></span>
      </el-form-item>
      <el-form-item label="">
        <el-button @click="updateUserInfo">保存修改</el-button>
        <!-- <el-button class="goto-home" @click="goto_home">返回</el-button> -->
      </el-form-item>
    </el-form>
		<el-dialog :visible.sync="dialogBindPhoneVisible" class="bind_phone-dialog" :close-on-click-modal="false" width="642px" top="calc(50vh - 236px)">
			<div slot="title" class="dialog-title">{{dialogTitle}}</div>
			<template v-if="bindStep === 1">
				<el-form :model="checkForm" :key="'account'" ref="checkForm">
					<el-form-item class="describe-box">
						<p>你正在进行敏感操作，继续操作需要验证您的身份</p>
						<div class="describe" v-if="isUpdata">更换号码后，将无法通过【原手机号码＋验证码】登录</div>
						<div class="describe" v-else>绑定手机后，你可通过【手机号码＋验证码】登录</div>
					</el-form-item>
					<el-form-item label="密码验证" prop="password" :rules="{ required: true, message: '密码不能为空', trigger: 'blur'}">
						<el-input :type="showPassword? 'text' : 'password'" maxlength="32" v-model="checkForm.password" placeholder="请输入当前账号密码" autocomplete="off" ref="password">
							<i slot="suffix" class="el-icon-invisible" @click="showPwd('showPassword')" :class="{see: showPassword}"></i>
						</el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer" :key="'account'">
					<el-button @click="dialogBindPhoneVisible = false" class="info">取消</el-button>
					<el-button :loading="loading" class="every" @click="bindPhoneNext('checkForm')">下一步</el-button>
				</div>
			</template>
			<template v-else-if="bindStep === 2">
				<el-form :model="phoneform" :key="'telPhone'" ref="phoneform" :rules="phoneFormRules">
					<el-form-item class="checked-box">
						<p v-if="isUpdata"><i></i>验证成功，请输入手机号码</p>
						<p v-else><i></i>验证成功，请输入新的手机号码</p>
					</el-form-item>
					<el-form-item label="手机号码" prop="mobile">
						<el-input v-model="phoneform.mobile" placeholder="请输入要绑定的手机号码" maxlength="11"></el-input>
					</el-form-item>
					<div style="display:flex">
						<el-form-item label="短信验证码" prop="authCode"  style="width:calc(100% - 114px);margin-right: 10px">
							<el-input v-model="phoneform.authCode" placeholder="请输入短信验证码" maxlength="6"></el-input>
						</el-form-item>
						<el-form-item :label="' '" class="get-check_code" style="width:104px">
							<el-button :loading="loadingCode" :class="{wait: waiting}" @click="getCheckCode('phoneform', 'getCodeTimer')">{{getCode}}</el-button>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer" :key="'telPhone'">
					<el-button @click="dialogBindPhoneVisible = false" class="info">取消</el-button>
					<el-button :loading="loading" type="primary" @click="enterBindPhone('phoneform')">确定</el-button>
				</div>
			</template>
			<template v-else-if="bindStep === 3">
				<div class="result-feedback" :key="'feedback'">
					<dl>
						<dd></dd>
						<dd>你已成功绑定手机号码</dd>
					</dl>
				</div>
				<div slot="footer" class="dialog-footer" style="text-align: center;" :key="'feedback'">
					<el-button style="width:0px;border:none;height:0px"></el-button>
					<el-button :loading="loading" style="margin-left: 0;" type="primary" @click="dialogBindPhoneVisible = false">确定</el-button>
				</div>
			</template>
		</el-dialog>
		<el-dialog :visible.sync="dialogUnbindPhoneVisible" class="unbind_phone-dialog" :close-on-click-modal="false" width="642px" top="calc(50vh - 236px)">
			<div slot="title" class="dialog-title">{{unbindDialogTitle}}</div>
			<template v-if="unbindStep === 1">
				<el-form :model="unbindPhoneForm" :key="'account'" ref="unbindPhoneForm" :rules="unbindPhoneFormRules">
					<el-form-item class="describe-box">
						<p>你正在进行敏感操作，继续操作需要验证您的身份</p>
						<div class="describe">解除绑定后，将无法通过【原手机号码＋验证码】登录</div>
					</el-form-item>
					<el-form-item label="密码验证" prop="password">
						<el-input :type="showPassword? 'text' : 'password'" maxlength="32" v-model="unbindPhoneForm.password" placeholder="请输入当前账号密码" autocomplete="off" ref="password">
							<i slot="suffix" class="el-icon-invisible" @click="showPwd('showPassword')" :class="{see: showPassword}"></i>
						</el-input>
					</el-form-item>
					<div style="display:flex">
						<el-form-item :label="`短信验证（接受手机号码${applyForm.mobile}）`" prop="authCode"  style="width:calc(100% - 114px);margin-right: 10px">
							<el-input v-model="unbindPhoneForm.authCode" placeholder="请输入短信验证码" maxlength="6"></el-input>
						</el-form-item>
						<el-form-item :label="' '" class="get-check_code" style="width:104px">
							<el-button :loading="loadingCode" :class="{wait: unbindWaiting}" @click="getUnbindCheckCode('unbindPhoneForm', 'getUnbindCodeTimer')">{{getUnbindCode}}</el-button>
						</el-form-item>
					</div>
				</el-form>
				<div slot="footer" class="dialog-footer" :key="1">
					<el-button @click="dialogUnbindPhoneVisible = false" class="info">取消</el-button>
					<el-button :loading="loading" type="primary" @click="unbindPhoneNext('unbindPhoneForm')">下一步</el-button>
				</div>
			</template>
			<template v-else-if="unbindStep === 2">
				<div class="result-feedback">
					<dl>
						<dd></dd>
						<dd>已解绑该手机号码</dd>
					</dl>
				</div>
				<div slot="footer" class="dialog-footer" style="text-align: center;" :key="2">
					<el-button style="width:0px;border:none;height:0px" class="info"></el-button>
					<el-button :loading="loading" style="margin-left: 0;" type="primary" @click="dialogUnbindPhoneVisible = false">确定</el-button>
				</div>
			</template>
		</el-dialog>
  </div>
</template>

<script>
import { getUserInfo, updateUserInfo } from '@/api/profile'
import { sendSmsAuthCode, addMobileCheck, saveMobile, removeMobile } from '@/api/login'
export default {
	name: 'personal_profile',
  data() {
		var validatePhone = (rule, value, callback) => {
			const reg = /^[1][3-9][0-9]{9}$/
			if (value == '' || value == undefined || value == null) {
				callback()
			} else {
				if (!reg.test(value) && value != '') {
					callback(new Error('请输入正确的手机号码'))
				} else {
					callback()
				}
			}
		}
		var validateNumber = (rule, value, callback) => {
			let numberReg = /^\d+$/; //纯数字
			if (value !== '') {
					if (!numberReg.test(value)) {
							callback(new Error('请输入6位数字验证码'))
					} else {
							callback()
					}
			} else {
					callback(new Error('验证码不能为空'))
			}
		}

		var validateEMail = (rule, value,callback) => {
			const reg =/^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9\.]+\.[a-z]+$/;
			if(value==''||value==undefined||value==null){
				callback(new Error('请输入正确的邮箱'));
			}else{
				if (!reg.test(value)){
					callback(new Error('请输入正确的邮箱'));
				} else {
					callback();
				}
			}
		}
    return {
			dialogBindPhoneVisible: false,
			dialogUnbindPhoneVisible: false,
			showPassword: false,
			bindStep:1,
			loading: false,
			loadingCode: false,
			getCode: '获取验证码',
			getUnbindCode: '获取验证码',
			getCodeTimer: null,  // 获取绑定验证码定时器
			getUnbindCodeTimer: null, // 获取解绑验证码定时器
			waiting: false,
			unbindWaiting: false,
			dialogTitle:'',
			unbindDialogTitle: '',
			unbindStep: 1,
			isUpdata: false, // 是否为切换手机号弹窗
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},
      applyForm: {
        id: this.$store.state.user.id,
        account: '',
        name: '',
        department: '',
        position: '',
        email: '',
        mobile: '',
        tel: ''
			},
			checkForm: {
				password: '',
				account: this.$store.state.user.account
			},
			phoneform:{
				account: this.$store.state.user.account,
				authCode: '',
				mobile: ''
			},
			unbindPhoneForm: {
				account: this.$store.state.user.account,
				password: '',
				authCode: ''
			},
			applyFormRules:{
				email: [
					{ required: true, message: '邮箱不能为空', trigger: 'blur' },
					{ validator: validateEMail, trigger: 'blur' }
				],
				name: [
					{ required: true, message: '姓名不能为空', trigger: 'blur' },
				]
			},
			phoneFormRules: {
				mobile: [
					{ required: true, message: '手机号码不能为空', trigger: 'blur' },
					{ validator: validatePhone, trigger: 'blur' }
				],
				authCode: [
					{ required: true, message: '验证码不能为空', trigger: 'blur' },
					{ min: 6, max: 6, message: '请输入6位数字验证码', trigger: 'blur'},
					{ validator: validateNumber, trigger: 'blur' }
				]
			},
			unbindPhoneFormRules: {
				password: [
					{ required: true, message: '密码不能为空', trigger: 'blur' },
				],
				authCode: [
					{ required: true, message: '验证码不能为空', trigger: 'blur' },
					{ min: 6, max: 6, message: '请输入6位数字验证码', trigger: 'blur'},
					{ validator: validateNumber, trigger: 'blur' }
				]
			}
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    async getUserInfo() {
			const { data } = await getUserInfo({ id: this.applyForm.id });
			this.$store.commit('profile/SET_LOGO', data.logo)
      this.assignObj(this.applyForm, data)
    },
    async updateUserInfo() {
			let validateResult =  ['email', 'name'].some(item => {
				let error = null;
				this.$refs.applyForm.validateField(item, (errorInfo) => {
					error = !!errorInfo
				});
				return error;
			})
			if(validateResult) {
				console.log('errorInfo');
			} else {
				const { data } = await updateUserInfo(this.applyForm);
				this.getUserInfo()
				this.$message.success('更新成功');
			}
    },
    showPwd(name) {
      this[name] = !this[name];
    },
    assignObj(obj1, obj2) {
      for (const key in obj2) {
        if (obj1.hasOwnProperty(key)) {
          obj1[key] = obj2[key]
        }
      }
		},
		bindPhone(isUpdata, timeoutName){
			if(isUpdata === 'update'){
				this.isUpdata = true;
			} else {
				this.isUpdata = false;
			}
			this.bindStep = 1;
			this.dialogBindPhoneVisible = true;
			this.dialogTitle = '账号安全验证';
			setTimeout(() => {
				this.$refs.checkForm.clearValidate();
			}, 0)
			this.clearTimeouts(timeoutName, () => {
				this.getCode = '获取验证码';
				this.waiting = false;
			});
	
		},
		unbindPhone(isUpdata, timeoutName){
			this.dialogUnbindPhoneVisible = true;
			this.unbindStep = 1;
			this.unbindDialogTitle = '账号安全验证';
			setTimeout(() => {
				this.$refs.unbindPhoneForm.clearValidate();
			}, 0)
			this.clearTimeouts(timeoutName, () => {
				this.getUnbindCode = '获取验证码';
				this.unbindWaiting = false;
			});
		},
		bindPhoneNext(formName){
			this.$refs[formName].validate((valid) => {
				this.loading = true;
				if (valid) {
					const postData = {
						...this[formName],
						id: 1
					}
					addMobileCheck(postData)
					.then(res => {
						if(this.isUpdata) {
							this.dialogTitle = '新手机号码码绑定';
						} else {
							this.dialogTitle = '手机号码绑定';
						}
						this.bindStep += 1;
						this.loading = false;
						this.resetForm(formName);
					})
					.catch(err => {
						this.loading = false;
					})
				} else {
					this.loading = false;
					return false;
				}
			});
		},
		unbindPhoneNext(formName){
			this.$refs[formName].validate(valid => {
				this.loading = true;
				if(valid){
					const postData = {
						...this[formName]
					}
					removeMobile(postData)
					.then(res =>{
						this.getUserInfo();
						this[formName].password = '';
						this[formName].authCode = '';
						setTimeout(() => {
							this.unbindDialogTitle = '解绑成功';
							this.unbindStep += 1;
						}, 0);
						this.resetForm(formName);
						this.loading = false;
					})
					.catch(err => {
						this.loading = false;
					})
				} else {
					console.log('submit error');
					this.loading = false;
					return false
				}
			})
		},
		getCheckCode(form, timeoutName){
			if(this.waiting){
				return false;
			}
			let postData;
			let checks;
			if(form == 'phoneform'){
				postData = {
					mobile: this[form].mobile,
					flag: 0
				}
				checks = ['mobile']
			} else {
				postData = {
					account: this[form].account,
					password: this[form].password,
					mobile: this.applyForm.mobile,
					flag: 2
				}
				checks = ['password']
			}
			this.$refs[form].validateField(checks, valid => {
				this.loadingCode = true;
				if(!valid) {
					sendSmsAuthCode(postData)
					.then(res => {
						this.waiting = true;
						this.getCode = '59s';
						this.countdown(59, () => {
							this.getCode = '获取验证码';
							this.waiting = false;
						}, 'getCode', timeoutName);
						this.$message.success('验证码已发送，请注意查收');
						this.loadingCode = false;
						// this.resetForm(formName);
					})
					.catch(err => {
						this.loadingCode = false;
					})
				} else {
					this.loadingCode = false;
					return false;
				}
			})
		},
		getUnbindCheckCode(form, timeoutName){
			if(this.unbindWaiting){
				return false;
			}
			let postData = {
				account: this[form].account,
				password: this[form].password,
				mobile: this.applyForm.mobile,
				flag: 2
			}
			this.$refs[form].validateField('password', valid => {
				this.loadingCode = true;
				if(!valid) {
					sendSmsAuthCode(postData)
					.then(res => {
						this.unbindWaiting = true;
						this.getUnbindCode = '59s';
						this.countdown(59, () => {
							this.getUnbindCode = '获取验证码';
							this.unbindWaiting = false;
						}, 'getUnbindCode', timeoutName)
						this.$message.success('验证码已发送，请注意查收');
						this.loadingCode = false;
						// this.resetForm(formName);
					})
					.catch(err => {
						this.loadingCode = false;
					})
				} else {
					this.loadingCode = false;
					return false;
				}
			})
		},
		enterBindPhone(formName) {
			this.$refs[formName].validate(valid => {
				this.loading = true;
				if(valid){
					const postData = {
						...this[formName]
					}
					saveMobile(postData)
					.then(res => {
						this.getUserInfo();
						this.loading = false;
						setTimeout(() => {
							this.dialogTitle = '绑定成功';
							this.bindStep += 1;
						}, 0)
						this.resetForm(formName);
					})
					.catch(err => {
						this.loading = false;
					})
				} else {
					console.log('submit error');
					this.loading = false;
					return false
				}
			})
		},
    countdown(remainTime, callback, updateText, timeoutName) {
			if(remainTime>0) {
				this[timeoutName] = setTimeout(() => {
					remainTime --;
					this[updateText] = remainTime + 's';
          this.countdown(remainTime, callback, updateText)
					// clearTimeout(this[timeoutName]);
					// this[timeoutName] = null;
				}, 1000)
        } else {
          callback();
        }
		},
		clearTimeouts(timeoutName, callback){
			clearTimeout(this[timeoutName]);
			this[timeoutName] = null;
			callback();
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		goto_home(){
			this.$router.push('/');
		}
  }
}
</script>
<style lang="scss">
.personal-profile {
  text-align: left;
  font-size: 14px;
  .el-form.apply-form {
    .el-form-item__label {
      text-align: left;
      color: #343438;
    }
		.el-form-item__error{
			top: -5px!important;
		}
    .el-form-item {
      margin: 0px 0 24px;
      width: calc(100% - 142px);
      min-height: 42px;
			line-height: 42px;
			@media only screen and (max-width: 1366px) {
				min-height: 36px;
				line-height: 36px;
			}
      .el-form-item__content {
        // .el-input--medium .el-input__inner {
        //   height: 34px;
        //   line-height: 34px;
        // }
        span {
          padding: 0 8px 0 14px;
        }
        a {
          margin: 0 8px;
          color: #514def;
        }
        .el-button {
          width: 200px;
					height: 42px;
					@media only screen and (max-width: 1366px) {
						height: 36px;
					}
          background: #514def;
          color: #ffffff;
          border-radius: 4px;
          border: none;
					&:hover{
         	 background: #5f5bfb;
					}
					&.goto-home{
						background: #69C72A;
						&:hover{
							background: #7CDD3B;
						}
					}
					span{
						padding: 0;
					}
        }
      }
      .el-form-item__error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        left: initial;
        top: 0px;
        right: 0px;
        transform: translateY(-100%);
      }
    }
  }
}
.unbind_phone-dialog, .bind_phone-dialog{
	// width: 642px;
	// height: 473px;
	// background: #FFFFFF;
	// border-radius: 5px;
	.el-dialog{
		height: 473px;
		background: #FFFFFF;
		border-radius: 5px;
		.el-dialog__header{
			padding: 30px 50px 0;
			.dialog-title{
				text-align: center;
				height: 14px;
				line-height: 14px;
			}
			.el-dialog__headerbtn{
				top: 18px;
				right: 18px;
			}
		}
		.el-dialog__body{
			padding: 0 50px;
			height: calc(100% - 132px);
			.el-form {
				.el-form-item {
					margin-bottom: 18px;
				}
				.el-form-item__label {
					// text-align: left;
					// color: #343438;
				}
				.el-icon-invisible{
					display: inline-block;
					width: 36px;
					height: 100%;
					background: url('~@/assets/images/btn_key_invisible_normal.png') no-repeat;
					background-position: center;
					cursor: pointer;
					&:hover {
						background-image: url('~@/assets/images/btn_key_invisible_hover.png');
					}
					&.see{
						background-image: url('~@/assets/images/btn_key_visible_normal.png');
						&:hover{
							background-image: url('~@/assets/images/btn_key_visible_hover.png');
						}
					}
				}
				.el-form-item{
					width: 100%;
					.el-form-item__error {
						color: #F56C6C;
						font-size: 12px;
						line-height: 1;
						padding-top: 4px;
						position: absolute;
						left: initial;
						top: 15px;
						right: 0px;
						transform: translateY(-100%);
					}
					&.describe-box{
						margin-bottom: 18px;
						p{
							margin-top: 42px;
							margin-bottom: 18px;
							height: 14px;
							line-height: 14px;
							color: #343438;
						}
						div.describe{
							height: 44px;
							line-height:44px;
							background: #EDEDFD;
							border-radius: 2px;
							padding-left:17px;
							color:#514DEF;
						}
					}
					&.checked-box{
						margin-bottom: 0px;
						p{
							margin-top: 28px;
							margin-bottom: 23px;
							height: 16px;
							line-height: 16px;
							color: #343438;
							i{
								background-image: url('~@/assets/images/icon_box_success.png');
								width: 16px;
								height: 16px;
								vertical-align: bottom;
								margin-right: 7px;
								display: inline-block;
							}
						}
					}
					.el-form-item__label{
						height: 14px;
						line-height: 14px;
						color: #343438;
						margin-bottom: 10px;
					}
			
					&.get-check_code{
						.el-button{
							border-color: #514DEF;
							color: #514DEF;
							background-color: #FFFFFF;
							height: 42px;
							@media only screen and (max-width: 1366px){
								height: 36px;
							}
							cursor: pointer;
							width: 104px;
							padding: 10px 0px;
							span{
								padding: 0;
							}
							&:hover {
								color: #FFFFFF;
								background-color: #5F5BFB;
								border-color: #5F5BFB;
							}
							&.wait, .wait:hover{
								cursor: not-allowed;
								color: #C4C3EF; 
								background-color: #FFFFFF;
								border-color: #D8D7FE;
							}
						}
					}
				}
			}
			.result-feedback{
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				dl{
					margin: auto;
					display: flex;
					flex-direction: column;
					align-items: center;
					dd{
						font-size: 14px;
						color: #343438;
						&:first-child{
							background-image: url('~@/assets/images/pic_box_success.png');
							margin-bottom: 50px;
							width: 107px;
							height: 107px;
						}
					}
				}
			}
		}
		.el-dialog__footer{
			padding: 0 50px;
			height: 42px;
			.el-button{
				height: 42px;
				line-height: 42px;
				@media only screen and (max-width: 1366px){
					height: 36px;
					line-height: 36px;
				}
				padding: 0;
				&:first-child{
					width: 100px;
					&:hover{
						background: initial !important;
					}
				}
				&:last-child{
					width: 150px;
				}
			}
		}
	}
}
</style>

<style lang="scss">
.personal-profile {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before {
    content: '';
    margin-right: 0px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label::after {
    content: '*';
    color: #ff4949;
    margin-left: 4px;
  }
}
</style>
